import { AxiosResponse } from "axios";
import { HandoverV2Detail } from "@/domain/entities/HandoverV2";
import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";

export class HandoverV2Mapper {
  convertGetDetailHandoverFromApi(res: AxiosResponse): HandoverV2Detail {
    return new HandoverV2Detail(convertSnakeToCamel(res.data?.data));
  }
}
